



















































import {
  defineComponent, reactive, computed, ref,
} from '@vue/composition-api';
import { useMutation } from '@vue/apollo-composable';
import axios from 'axios';
import CommonConfirmDialog from '@/components/Dialog/CommonConfirmDialog.vue';
import CommonFavoriteButton from '@/components/CommonCustomButton/CommonFavoriteButton.vue';
import CommonCheckButton from '@/components/CommonCustomButton/CommonCheckButton.vue';
import image from '@/table/image';

import updateImageGQL from '@/gql/updateImage.gql';
import deleteImageGQL from '@/gql/deleteImage.gql';

import cdn from '@/cdn';

const CommonImageTable = defineComponent({
  setup(props: any, context: any) {
    function computedImage(id: any) {
      // eslint-disable-next-line
      props.value.forEach((element: any) => {
        if (element.id === id) return 'vivat/icons/check-checked.png';
      });
      return 'vivat/icons/check-empty.png';
    }

    const editVariable = reactive({
      type: '',
      item: {
        id: '', filename: '', folder: '', active: false, isMainImage: true, uploadedBy: {}, isBlackBackground: false,
      },
    });

    const updateImageMutation = useMutation(
      updateImageGQL,
      () => ({
        variables: {
          id: editVariable.item?.id,
          isActive: editVariable.type === 'active' ? !editVariable.item.active : editVariable.item.active,
          isMain: editVariable.type === 'main' ? !editVariable.item.isMainImage : editVariable.item.isMainImage,
          isBlack: editVariable.type === 'color' ? !editVariable.item.isBlackBackground : editVariable.item.isBlackBackground,
        },
        optimisticResponse: {
          __typename: 'Mutation',
          updateImage: {
            __typename: 'Image',
            id: editVariable.item?.id,
            active: editVariable.type === 'active' ? !editVariable.item.active : editVariable.item.active,
            filename: editVariable.item.filename,
            folder: props.folder,
            isBlackBackground: 'color' ? !editVariable.item.isBlackBackground : editVariable.item.isBlackBackground,
            isMainImage: editVariable.type === 'main' ? !editVariable.item.isMainImage : editVariable.item.isMainImage,
            uploadedBy: {
              ...editVariable.item.uploadedBy,
              updatedAt: new Date(),
            },
          },
        },
      }),
    );

    const _mainImage = computed(() => {
      // eslint-disable-next-line
      const temp = props.value.find((item: any) => item.isMainImage === true);
      return temp;
    });

    function updateImage(item: any, type: string) {
      editVariable.item = item;
      editVariable.type = type;
      updateImageMutation.mutate();
      const _value = props.value.map((element: any) => {
        if (element.id === editVariable.item.id) {
          return {
            ...element,
            isMainImage: editVariable.type === 'main' ? !editVariable.item.isMainImage : editVariable.item.isMainImage,
            active: editVariable.type === 'active' ? !editVariable.item.active : editVariable.item.active,
            isBlackBackground: editVariable.type === 'color' ? !editVariable.item.isBlackBackground : editVariable.item.isBlackBackground,
          };
        }
        return element;
      });
      context.emit('input', _value);
      if (type === 'main' && _mainImage.value !== undefined) {
        const _newMainImage = editVariable.item;
        editVariable.item.id = _mainImage?.value.id;
        editVariable.item.active = _mainImage?.value.active;
        editVariable.item.filename = _mainImage?.value.filename;
        editVariable.item.folder = props.folder;
        editVariable.item.isBlackBackground = _mainImage?.value.isBlackBackground;
        editVariable.item.isMainImage = _mainImage?.value.isMainImage;
        editVariable.item.uploadedBy = _mainImage?.value.uploadedBy;
        updateImageMutation.mutate();
        const __value = _value.map((element: any) => {
          if (element.id === _mainImage?.value.id) {
            return {
              ...element,
              isMainImage: editVariable.type === 'main' ? !editVariable.item.isMainImage : editVariable.item.isMainImage,
            };
          }
          return element;
        });
        context.emit('input', __value);
      }
    }

    function viewImage(item: any) {
      window.open(cdn.access(item.item.folder, item.item.filename), '_blank');
    }

    async function downloadImage(url: string) {
      const base64 = await axios
        .get(url, {
          responseType: 'arraybuffer',
        })
        .then((response) => Buffer.from(response.data, 'binary').toString('base64'));
      const img = new Image();
      img.src = `data:image/jpeg;base64, ${base64}`;
      return img;
    }

    const removedId = ref('');
    const deleteImageMutation = useMutation(
      deleteImageGQL,
      () => ({
        variables: {
          id: removedId.value,
        },
        optimisticResponse: {
          __typename: 'Mutation',
          deleteImage: {
            __typename: 'Image',
            id: removedId.value,
          },
        },
      }),
    );
    function onDeleteImage() {
      const _value = props.value.filter((item: any) => item.id !== removedId.value);
      context.emit('input', _value);
    }

    const computedImageTable = computed(() => {
      if (props.noMainImage) {
        return {
          ...image,
          columns: image.columns.filter((elm) => elm !== '_favoriteControls'),
        };
      }
      return image;
    });

    return {
      image: computedImageTable,
      viewImage,
      removedId,
      computedImage,
      onDeleteImage,
      deleteImageMutation,
      cdnAccessByFolder: cdn.accessByFolder,
      updateImage,
      _mainImage,
      downloadImage,
      editVariable,
    };
  },
  props: {
    value: {
      type: Array,
      default() { return []; },
    },
    noCheckbox: {
      type: Boolean,
      default() { return false; },
    },
    noMainImage: {
      type: Boolean,
      default() { return false; },
    },
    folder: {
      type: String,
      required: true,
    },
  },
  components: {
    CommonConfirmDialog,
    CommonFavoriteButton,
    CommonCheckButton,
  },
});

export default CommonImageTable;
